import { render, staticRenderFns } from "./VehicleOptionMultiSelect.vue?vue&type=template&id=b08aece0&scoped=true&lang=pug"
import script from "./VehicleOptionMultiSelect.vue?vue&type=script&lang=js"
export * from "./VehicleOptionMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08aece0",
  null
  
)

export default component.exports